import { UpdateWeatherWallDto } from '../../../types/models/UpdateWeatherWallDto';
import { UpdateWeatherWindowDto } from '../../../types/models/UpdateWeatherWindowDto';
import { MeasurementData } from '../../weather/types';

export interface UpdateWeatherWall extends UpdateWeatherWallDto {
  id: number;
}

export interface UpdateWeatherWindow extends UpdateWeatherWindowDto {
  id: number;
}

export type RangeUnit = 'hours' | 'days' | 'weeks' | 'months';
export const rangeUnitList: RangeUnit[] = ['hours', 'days', 'weeks', 'months'];

export type WeatherWallGrid = {
  name: string;
  rows: number;
  columns: number;
};

export interface WeatherWindowForm {
  id?: number;
  pos_x: number;
  pos_y: number;
  weather_wall_id: number;
  location_id: string | number | undefined;
  measurement: MeasurementData | undefined | '';
  range_unit: RangeUnit | undefined | '';
  range: number | undefined | string;
  forecast: string;
}

export interface Coordinates {
  x: number;
  y: number;
}
